import { CollectionViewer } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';

import { interval } from 'rxjs';
import { map, takeUntil, skip } from 'rxjs/operators';

import { AppState, Selectors } from 'store/root-reducer';
import * as CustomerActions from 'store/actions/customer.actions';

import { CustomerBatchUpload } from 'modules/shared/models/customer.models';
import { GetCustomersBatchUploadsResponse } from 'store/models/customer.models';

import { BaseDataSource } from 'modules/shared/data-source/base.data-source';

export class CustomersBatchUploadsHistoryDataSource extends BaseDataSource<CustomerBatchUpload> {

  constructor(private store: Store<AppState>) {
    super();
    this.initLoading();
    this.setDataObservable();
    this.pullFiles();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    super.disconnect(collectionViewer);
    this.store.dispatch(new CustomerActions.ClearCustomersBatchUploadsList());
  }

  private pullFiles(): void {
    interval(3000)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.loadData());
  }

  initLoading(): void {
    this.isLoading$ = this.store.select(Selectors.customer.getLoading)
      .pipe(
        takeUntil(this.unsubscribe$),
        map((customerLoading: Array<CustomerActions.CustomerActionTypes>) => {
          return customerLoading.includes(CustomerActions.CustomerActionTypes.GET_CUSTOMERS_BATCH_UPLOADS_LIST);
        })
      );
  }

  setDataObservable(): void {
    this._dataObservable$ = this.store
      .select(Selectors.customer.getCustomersBatchUploads)
      .pipe(
        skip(1),
        map(
          (allFilesResponse: GetCustomersBatchUploadsResponse) => {
            this.paginator.length = allFilesResponse.count;
            return (allFilesResponse.results as Array<CustomerBatchUpload>);
          }
        ),
        takeUntil(this.unsubscribe$)
      );
  }

  loadData(): void {
    this.store.dispatch(new CustomerActions.GetCustomersBatchUploadsList({ params: this.payload }));
  }
}
